import * as cmsApi from '../../api/cms/shorts'
import { useQuery } from '@tanstack/react-query'
import shuffle from 'shuffle-array'

const useShorts = () => {
    const { isLoading: isLoadingShorts, isError: isErrorShorts, error: errorShorts, data: shorts } = useQuery({
        queryKey: ['shortsExplore'],
        queryFn: async () => {
            const response = await cmsApi.getShortsByCategory('Staff')
            const json = await response.json() 

            if (!response.ok) throw new Error(json.error)

            return json?.data.length > 0 ? shuffle(json.data) : []
        },
        refetchOnWindowFocus: false // no refetch when window back to focus
    }) 

    return {
        isLoadingShorts,
        isErrorShorts,
        errorShorts,
        shorts
    }
}

export default useShorts